module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-600x338-0080aef8a52b65a449e5d20d3bde1bf1.png";